import styled from 'styled-components';
import vars from './vars';

export const Input = styled.input<{ hasError?: boolean; hasWarning?: boolean }>`
    width: 100%;
    box-sizing: border-box;
    padding: 8px 12px;
    border: 1px solid ${(p) => (p.hasError ? vars.dangerColor : vars.dividerColor)};
    border-radius: 6px;
    font: inherit;
    /* A warning tints the field and leaves the border and focus alone: the value is
       accepted, it just needs a second look. */
    background-color: ${(p) => (p.hasWarning ? vars.warningTintSoft : 'rgb(255, 255, 255)')};

    &:focus {
        outline: none;
        border-color: ${vars.accentColor};
    }

    &:disabled,
    &[readonly] {
        background-color: rgba(0, 0, 0, 0.05);
        color: #666;
        cursor: not-allowed;
    }

    &[type='time'],
    &[type='date'] {
        appearance: none;
        -webkit-appearance: none;
        color: ${vars.foregroundColor};
        -webkit-text-fill-color: ${vars.foregroundColor};
    }

    &[type='time']::-webkit-calendar-picker-indicator,
    &[type='date']::-webkit-calendar-picker-indicator {
        display: none;
    }

    &[type='time']::-webkit-date-and-time-value,
    &[type='date']::-webkit-date-and-time-value {
        text-align: left;
    }

    /* WebKit/Safari renders type='time'/'date' with extra intrinsic height vs
       text/number. Force a uniform height so all inputs line up. */
    height: 37px;
`;
